module.exports = __webpack_public_path__ + "img/steam_wishlist_big.d4dfbd2d.png";